import { render } from "./OptionalSignUp.vue?vue&type=template&id=5b6d8a80&scoped=true"
import script from "./OptionalSignUp.vue?vue&type=script&lang=ts"
export * from "./OptionalSignUp.vue?vue&type=script&lang=ts"

import "./OptionalSignUp.vue?vue&type=style&index=0&id=5b6d8a80&scoped=true&lang=css"
import "./OptionalSignUp.vue?vue&type=style&index=1&id=5b6d8a80&lang=css"
script.render = render
script.__scopeId = "data-v-5b6d8a80"

export default script